import { render, staticRenderFns } from "./RelationstypAuswahlwertePage.vue?vue&type=template&id=1a30d0cc"
import script from "./RelationstypAuswahlwertePage.vue?vue&type=script&lang=js"
export * from "./RelationstypAuswahlwertePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports